import * as BABYLON from "babylonjs";
import config from "../config";
export function copymesh(mesh, name) {
  let newMesh = mesh.clone();
  // let r = mesh.albedoColor.r
  // let g = mesh.albedoColor.g
  // let b = mesh.albedoColor.b
  try {
    newMesh.material = mesh.material.clone();
  } catch (error) {}

  newMesh.position = new BABYLON.Vector3(0.0, 0.0, 0.0);
  newMesh.name = name;
  return newMesh;
}

export function showIns(name, isShow) {
  //name = 'product3_1_0_battery_0_1'
  var meshes = levelsShowIns.scene.meshes;
  for (let i = 0; i < meshes.length; i++) {
    if (meshes[i].id === name) {
      console.log(meshes[i]);
      meshes[i].isVisible = isShow;
    }
  }
}
export function meshIns(mesh, name) {
  // 模型实例化

  let box = BABYLON.MeshBuilder.CreateBox(name, {
    width: 0.001 || config.battery.width,
    height: 0.001 || config.battery.height,
    depth: 0.001 || config.battery.depth
  });
  box.visibility = 0;

  // var newInstance = mesh.createInstance(name);
  // box.addChild(newInstance)

  let meshs = mesh.getChildMeshes();
  for (let index = 0; index < meshs.length; index++) {
    if (!meshs[index].registerInstancedBufferColor) {
      meshs[index].registerInstancedBuffer("color", 4);
      meshs[index].registerInstancedBufferColor = true;
    }
    var newInstance = meshs[index].createInstance(name);
    newInstance.instancedBuffers.color = new BABYLON.Color4(1, 1, 1, 1);
    // let r = mesh.albedoColor.r
    // let g = mesh.albedoColor.g
    // let b = mesh.albedoColor.b
    // newMesh.material.albedoColor = new BABYLON.Vector3(r, g, b);
    // newInstance.position = new BABYLON.Vector3(0.0, 0.0, 0.0);
    box.addChild(newInstance);
  }
  return box;
}

export function sleep(t) {
  return new Promise(reslove => {
    setTimeout(reslove, t);
  });
}

export function ScreenToWorld(point, camera) {
  var viewport = camera.viewport.toGlobal(
    engine.getRenderWidth(),
    engine.getRenderHeight()
  );

  return BABYLON.Vector3.Unproject(
    new BABYLON.Vector3(point.x, point.y, 0),
    viewport.width,
    viewport.height,
    BABYLON.Matrix.Identity(),
    camera.getViewMatrix(),
    camera.getProjectionMatrix()
  );
}

export function worldToScreen(point, camera, scene, engine) {
  return BABYLON.Vector3.Project(
    point,
    BABYLON.Matrix.Identity(),
    scene.getTransformMatrix(),
    camera.viewport.toGlobal(engine.getRenderWidth(), engine.getRenderHeight())
  );
}



// WEBPACK FOOTER //
// ./src/components/webgl/LevelsShow/Tools/index.js